<template>
    <transition-group :name="transitionName" tag="div" class="link-move-container">
        <slot></slot>
    </transition-group>
</template>

<script>
    export default {
        name: 'link-move-container',
        props: {
            direction: {
                type: String,
                default: 'bottom-right',
                desc: 'item入场出场动画的方向',
                validator(val) {
                    return LinkUtils.oneOf(val, [
                        'left',
                        'right',
                        'top',
                        'bottom',
                        'left-top',
                        'top-left',
                        'right-top',
                        'top-right',
                        'left-bottom',
                        'bottom-left',
                        'right-bottom',
                        'bottom-right',
                    ]);
                },
            }
        },
        computed: {
            transitionName() {
                return `link-move-container-${this.direction}`;
            },
        }
    };
</script>

<style lang="scss">
    .link-move-item {
        @include transition-all;
        box-sizing: border-box;
    }

    .link-move-container {
        display: inline-block;
        box-sizing: border-box;
    }

    $move-directions: (
        top:(x:0, y:-30%),
        left:(x:-80%, y:0),
        right:(x:80%, y:0),
        bottom:(x:0, y:30%),
        left-top:(x:-80%, y:-30%),
        top-left:(x:-80%, y:-30%),
        right-top:(x:80%, y:-30%),
        top-right:(x:80%, y:-30%),
        left-bottom:(x:-80%, y:30%),
        bottom-left:(x:-80%, y:30%),
        right-bottom:(x:80%, y:30%),
        bottom-right:(x:80%, y:30%),
    );

    @each $key, $value in $move-directions {
        .link-move-container-#{$key}-enter, .link-move-container-#{$key}-leave-to {
            opacity: 0;
            transform: translateX(map_get($value, x)) translateY(map_get($value, y));
        }
        .link-move-container-#{$key}-leave-active {
            position: absolute;
        }
    }

</style>
